import type { GetCompassAppTokenResponse } from 'src/types/proto/services/auth_public_service';
import { create } from '../axios';

export async function getCompassToken() {
  const axios = create('/api/');
  return axios.get<GetCompassAppTokenResponse>('/auth/compass_app_token');
}
